module.exports = __webpack_public_path__ + "img/Frame_36.8f1ec8d4.png";